import { render } from "./Notifications.vue?vue&type=template&id=fe5460fc&scoped=true&lang=pug"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=fe5460fc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5460fc"]])

export default __exports__